import React from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  CardTitle,
  CardText,
  CardImg
} from "reactstrap";
import "./index.scss";
import icon_apple_store from "../../assets/images/icon_apple_store.png";
import icon_google_store from "../../assets/images/icon_google_play.png";
class VistaApps extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false
    };
  }
  componentDidMount() { }
  render() {
    return (
      <div>
        <Row className="no-gutters">
          <Col>
            <Card className="header-toolbar-menu">
              <CardBody className="text-center">
                <span className="text-white  header-toolbar-menu-text-size">
                  Apps disponibles
                </span>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={6} lg={6}>
            <Card>
              <Row className="m-4">
                <Col xs={12} sm={12} md={12} lg={6}>
                  <Row>
                    <Col>
                      <div className="p-2">
                        <CardImg
                          className="mx-auto d-block"
                          src="imagenes/apps/logos/1.png"
                          alt="En casa yo reciclo"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="p-2">
                        <CardImg
                          className="mx-auto d-block"
                          src="imagenes/apps/logos/2.png"
                          alt="En casa yo reciclo"
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col xs={12} sm={12} md={12} lg={6}>
                  <Row>
                    <Col>
                      <CardTitle>
                        <p className="text-primary font-weight-bold h3">
                          En casa yo reciclo
                      </p>
                      </CardTitle>
                      <CardText>
                        “En casa yo reciclo” es un aplicativo creado por el
                        Ministerio del Ambiente para que la ciudadania pueda
                        conocer los lugares donde llevar los residuos sólidos
                        reciclables que separen en sus casas o centros de
                        trabajo.
                    </CardText>
                      <Row>
                        <Col>
                          <a
                            href="https://play.google.com/store/apps/details?id=pe.gob.minam.recycleapp"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <CardImg src={icon_google_store} />
                          </a>
                        </Col>
                        <Col>
                          <a
                            href="https://apps.apple.com/us/app/en-casa-yo-reciclo/id1455493815"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <CardImg src={icon_apple_store} />
                          </a>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card>
          </Col>

          <Col xs={12} sm={12} md={6} lg={6}>
            <Card>
              <Row className="m-4">
                <Col xs={12} sm={12} md={12} lg={6}>
                  <Row>
                    <Col>
                      <div className="p-2">
                      <CardImg
                      className="mx-auto d-block"
                      src="imagenes/apps/logos/3.png"
                      alt="Ministerio del Ambiente"
                    />
                      </div>
                    </Col>
                    <Col>
                      <div className="p-2">
                      <CardImg
                      className="mx-auto d-block"
                      src="imagenes/apps/logos/4.png"
                      alt="Ministerio del Ambiente"
                    />
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col xs={12} sm={12} md={12} lg={6}>
                  <Row>
                    <Col>
                      <CardTitle>
                        <p className="text-primary font-weight-bold h3">
                        Ministerio del Ambiente
                      </p>
                      </CardTitle>
                      <CardText>
                      Nuestro aplicativo móvil tiene como principal interés de
                      fomentar y facilitar el control ciudadano de la
                      actividad administrativa, así como contar con
                      instrumentos que permitan dotar de eficacia a los
                      procedimientos de atención de denuncias ante el
                      Ministerio del Ambiente.
                    </CardText>
                    <Row>
                      <Col>
                        <a
                          href="https://play.google.com/store/apps/details?id=pe.gob.minam"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <CardImg src={icon_google_store} />
                        </a>
                      </Col>
                      <Col></Col>
                    </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={6} lg={6}>
            <Card>
              <Row className="m-4">
                <Col xs={12} sm={12} md={12} lg={6}>
                  <Row>
                    <Col>
                      <div className="p-2">
                        <CardImg
                          className="mx-auto d-block"
                          src="imagenes/apps/logos/5.png"
                          alt="Oefa"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="p-2">
                        <CardImg
                          className="mx-auto d-block"
                          src="imagenes/apps/logos/6.png"
                          alt="Oefa"
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col xs={12} sm={12} md={12} lg={6}>
                  <Row>
                    <Col>
                      <CardTitle>
                        <p className="text-primary font-weight-bold h3">
                        Oefa
                      </p>
                      </CardTitle>
                      <CardText>
                      El aplicativo OEFA permite a los ciudadanos presentar denuncias ambientales, solicitar cualquier información de acceso público con la que cuente el OEFA, recabar información sobre la ubicación de nuestras sedes a nivel nacional y realizar consultas ciudadanas.
                    </CardText>
                      <Row>
                      <Col>
                        <a
                          href="https://play.google.com/store/apps/details?id=pe.gob.oefa.movil"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <CardImg src={icon_google_store} />
                        </a>
                      </Col>
                      <Col></Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card>
          </Col>

          <Col xs={12} sm={12} md={6} lg={6}>
            <Card>
              <Row className="m-4">
                <Col xs={12} sm={12} md={12} lg={6}>
                  <Row>
                    <Col>
                      <div className="p-2">
                      <CardImg
                      className="mx-auto d-block"
                      src="imagenes/apps/logos/7.png"
                      alt="Senace"
                    />
                      </div>
                    </Col>
                    <Col>
                      <div className="p-2">
                      <CardImg
                      className="mx-auto d-block"
                      src="imagenes/apps/logos/8.png"
                      alt="Senace"
                    />
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col xs={12} sm={12} md={12} lg={6}>
                  <Row>
                    <Col>
                      <CardTitle>
                        <p className="text-primary font-weight-bold h3">
                        Senace
                      </p>
                      </CardTitle>
                      <CardText>
                      El Servicio Nacional de Certificación Ambiental para las Inversiones Sostenibles (Senace) es un organismo público técnico especializado, adscrito al Ministerio del Ambiente.
                    </CardText>
                    <Row>
                      <Col>
                        <a
                          href="https://play.google.com/store/apps/details?id=pe.gob.senace"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <CardImg src={icon_google_store} />
                        </a>
                      </Col>
                      <Col></Col>
                    </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xs={12} sm={12} md={6} lg={6}>
            <Card>
              <Row className="m-4">
                <Col xs={12} sm={12} md={12} lg={6}>
                  <Row>
                    <Col>
                      <div className="p-2">
                        <CardImg
                          className="mx-auto d-block"
                          src="imagenes/apps/logos/9.png"
                          alt="Sismos Perú"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="p-2">
                        <CardImg
                          className="mx-auto d-block"
                          src="imagenes/apps/logos/10.png"
                          alt="Sismos Perú"
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col xs={12} sm={12} md={12} lg={6}>
                  <Row>
                    <Col>
                      <CardTitle>
                        <p className="text-primary font-weight-bold h3">
                        Sismos Perú
                      </p>
                      </CardTitle>
                      <CardText>
                      Esta es una versión de la aplicación Sismos Perú para dispositivos móviles con Android. Esta aplicación recibe notificaciones de eventos sísmicos reportados en tiempo real por el Instituto Geofísico del Perú.
                    </CardText>
                      <Row>
                      <Col>
                        <a
                          href="https://play.google.com/store/apps/details?id=sistemasfireg.igp.org.sismosperu"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <CardImg src={icon_google_store} />
                        </a>
                      </Col>
                      <Col></Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

      </div>
    );
  }
}

export default VistaApps;
